import { render, staticRenderFns } from "./VTooltip.vue?vue&type=template&id=64de05be&scoped=true&"
import script from "./VTooltip.vue?vue&type=script&lang=js&"
export * from "./VTooltip.vue?vue&type=script&lang=js&"
import style0 from "./VTooltip.vue?vue&type=style&index=0&id=64de05be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de05be",
  null
  
)

export default component.exports